<script>
    import { createEventDispatcher, getContext, onMount } from 'svelte';
    import { t } from '../../../lang/lang.js'
    import box, { boxTitle } from '../../../box.js';
    import { apiRequest } from '../../../utils.js';
    import PopupTitle from '../PopupTitle.svelte';
    import PopupButton from '../forms/PopupButton.svelte';
    import InputDimension from '../forms/InputDimension.svelte';
    import boxBigSvg from './svg/boxBig.svg';
    import boxSmallSvg from './svg/boxSmall.svg';
    import client from '../../../client.js';

    let dispatch = createEventDispatcher();
    let inputs = {
        depth: null,
        width: null,
        height: null,
    };
    let options = getContext('options');

    onMount(() => {
        inputs.depth.focus();
    });

    setBoxDefaults();

    function setBoxDefaults() {
        ['width', 'height', 'depth', 'unit'].forEach(k => {
            if (!$box[k] && options['box_' + k]) {
                $box[k] = options['box_' + k];
            }
        });

        if (!$box.unit) {
            $box.unit = 'cm';
        }
    }

    function submit() {
        if (validate()) {
            dispatch('loading');
            loadUrls();
        }
    }

    function validate() {
        for (let name in inputs) {
            const input = inputs[name];
            if (!input.validate()) {
                input.focus();
                return false;
            }
        }
        return true;
    }

    async function loadUrls() {
        const url = options.domain + 'api/urls';
        let data = {
            url: document.URL,
            box_width: $box.width,
            box_height: $box.height,
            box_depth: $box.depth,
            box_unit: $box.unit,
        };
        const response = await apiRequest(url, data),
            unsupported = client.AR;
        if (unsupported) {
            const title = boxTitle();
            dispatch('showAr', {...response, title});
        }
        dispatch('share', {...response, unsupported});
    }
</script>

<div class="arsize_size_block">
    <PopupTitle>
        { t('widget.title_size') }
    </PopupTitle>
    <div class="arsize_title_img">
        <div class="arsize_title_img_sm">
            {@html boxSmallSvg}
        </div>
        <div class="arsize_title_img_big">
            {@html boxBigSvg}
        </div>
    </div>
    <div class="arsize_params">
        <div class="arsize_text">{ t('widget.note_use') }</div>
        <div class="arsize_selects_block">
            {#each Object.keys(inputs) as name}
                <div class="arsize_selects_block_item">
                    <InputDimension {name}
                        error={false}
                        bind:this={inputs[name]}
                        bind:unit={$box.unit}
                        bind:value={$box[name]} />
                </div>
            {/each}
            <div class="arsize_selects_block_item">
                <PopupButton on:click={submit}>
                    <span slot="icon" class="arsize_btn_span_icon_cube"></span>
                    <span slot="text">{ t('widget.try') }</span>
                </PopupButton>
            </div>
        </div>
    </div>
</div>

<style>
    .arsize_selects_block_item {
        flex: 0 0 25%;
        max-width: 25%;
    }
    .arsize_title_img {
        text-align: center;
    }
    .arsize_title_img_big {
        display: block;
    }
    .arsize_title_img_sm {
        display: none;
    }
    .arsize_params {
        padding: 48px 64px;
    }
    .arsize_text {
        margin-bottom: 24px;
    }
    .arsize_selects_block {
        display: flex;
    }
    .arsize_btn_span_icon_cube {
        display: block;
        align-self: center;
        width: 20px;
        height: 20px;
        background: transparent url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAwMDYgMjAuNUMxMC4xOTM5IDIwLjUgMTAuMzgzNCAyMC40NDk4IDEwLjU0NzQgMjAuMzU1MkwxOC44MDE0IDE1LjU5MzNDMTkuMTAzIDE1LjQxOTMgMTkuMjg2MyAxNS4xMTQxIDE5LjI4NjMgMTQuNzg1N1Y2LjIxNDI5QzE5LjI4NjMgNS44ODU5MiAxOS4xMDMgNS41ODA3MSAxOC44MDE0IDUuNDA2NjdMMTAuNTQ3NCAwLjY0NDc2NEMxMC4yMTI4IDAuNDUxNzQ1IDkuNzg4MyAwLjQ1MTc0NSA5LjQ1MzczIDAuNjQ0NzY0TDEuMTk5NzYgNS40MDY2N0MwLjg5ODEgNS41ODA3MSAwLjcxNDg0MyA1Ljg4NTkyIDAuNzE0ODQ0IDYuMjE0MjlWMTQuNzg1N0MwLjcxNDg0MyAxNS4xMTQxIDAuODk4MSAxNS40MTkzIDEuMTk5NzYgMTUuNTkzM0w5LjQ1MzczIDIwLjM1NTJDOS42MTc3MSAyMC40NDk4IDkuODA3MTkgMjAuNSAxMC4wMDA2IDIwLjVaTTE3LjIyMjggMTQuMjU4MUwxMS4wMzIzIDE3LjgzMzNWMTEuNTA0OEwxNy4yMjI4IDcuOTMzMzNWMTQuMjU4MVpNMTAuMDAwNiAyLjU3NTI0TDE2LjMwNzYgNi4yMTQyOUwxMC4wMDA2IDkuODUzMzNMMy42OTM0OSA2LjIxNDI5TDEwLjAwMDYgMi41NzUyNFpNOC45Njg4MSAxNy44MzMzTDIuNzc4MzQgMTQuMjYxOVY3LjkzMzMzTDguOTY4ODEgMTEuNTA0OFYxNy44MzMzWiIgZmlsbD0id2hpdGUiPjwvcGF0aD4KPC9zdmc+") no-repeat center;
        margin-right: 6px;
    }
    @media (max-width: 1279.98px) {
        .arsize_title_img {
            padding-top: 12px;
        }
        .arsize_title_img_big {
            display: none;
        }
        .arsize_title_img_sm {
            display: block;
        }
        .arsize_params {
            padding: 20px 18px;
        }
        .arsize_text {
            margin-bottom: 18px;
        }
        .arsize_selects_block {
            flex-wrap: wrap;
        }
        .arsize_selects_block_item {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 12px;
        }
    }
</style>